import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { DayOfWeek } from 'core/day-of-week';

export const AllWorkingDayConfig: WorkingDaysConfiguration = {
  [DayOfWeek.Monday]: true,
  [DayOfWeek.Tuesday]: true,
  [DayOfWeek.Wednesday]: true,
  [DayOfWeek.Thursday]: true,
  [DayOfWeek.Friday]: true,
  [DayOfWeek.Saturday]: true,
  [DayOfWeek.Sunday]: true,
};
